"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFallbackShape = useFallbackShape;
var _react = require("react");
var _borderRadius = require("../tokens/borderRadius");
const WIDTH_MODIFIERS = [0.5, 0, 0.6, 0.8, 0.1, 0.9, 0.4, 0.2, 0.7, 0.3];
function useFallbackShape(shape, baseWidth, options) {
  const width = (0, _react.useMemo)(() => {
    // When rectangle, lets vary the width a bit so things are
    // a little less... uniform. Variety is nice.
    if (shape === 'rectangle' && typeof baseWidth === 'number' && (!(options !== null && options !== void 0 && options.disableRandomRectWidth) || (options === null || options === void 0 ? void 0 : options.rectWidthVariant) !== undefined)) {
      const modifier = (options === null || options === void 0 ? void 0 : options.rectWidthVariant) !== undefined ? WIDTH_MODIFIERS[options.rectWidthVariant % WIDTH_MODIFIERS.length] : Math.random();
      const quarter = Math.round(baseWidth / 4);
      const min = Math.max(baseWidth - quarter, 1);
      const max = baseWidth + quarter;
      return Math.floor(modifier * (max - min + 1)) + min;
    }

    // All other shapes need a fixed aspect ratio
    return baseWidth;
  }, [baseWidth, options, shape]);
  const borderRadius = (0, _react.useMemo)(() => {
    if (shape === 'circle' && Number.isInteger(width)) {
      return Number(width) / 2;
    }
    return shape === 'squircle' ? _borderRadius.borderRadius.rounded : 0;
  }, [shape, width]);
  return (0, _react.useMemo)(() => ({
    borderRadius,
    width
  }), [borderRadius, width]);
}